module.exports = __webpack_public_path__ + "media/images/sp/stores/omiya/omiya_concept_02-93738a08889f3767d533ec6dda32eb80.jpg";